import { useTranslation } from 'react-i18next';

export const keyPrefix = 'sort_roles';
export const useSortRoleListTranslation = () => useTranslation('entities', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    name_asc: 'По названию (от А до Я)',
    name_desc: 'По названию (от Я до А)',
    create_time_desc: 'По дате создания (сначала новые)',
    create_time_asc: 'По дате создания (сначала старые)',
    update_time_desc: 'По дате изменения (сначала новые)',
    update_time_asc: 'По дате изменения (сначала старые)',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    name_asc: 'By name (A to Z)',
    name_desc: 'By name (Z to A)',
    create_time_desc: 'By creation date (newest first)',
    create_time_asc: 'By creation date (oldest first)',
    update_time_desc: 'By update date (newest first)',
    update_time_asc: 'By update date (oldest first)',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    name_asc: 'Por nome (de A a Z)',
    name_desc: 'Por nome (de Z a A)',
    create_time_desc: 'Por data de criação (mais recentes primeiro)',
    create_time_asc: 'Por data de criação (mais antigos primeiro)',
    update_time_desc: 'Por data de atualização (mais recentes primeiro)',
    update_time_asc: 'Por data de atualização (mais antigos primeiro)',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    name_asc: 'Por nombre (de la A a la Z)',
    name_desc: 'Por nombre (de la Z a la A)',
    create_time_desc: 'Por fecha de creación (más recientes primero)',
    create_time_asc: 'Por fecha de creación (más antiguos primero)',
    update_time_desc: 'Por fecha de actualización (más recientes primero)',
    update_time_asc: 'Por fecha de actualización (más antiguos primero)',
  },
}) as Record<string, unknown>;
